// RN04: texto fixo, não deve ser alterado dinamicamente (nem vir de API).
export const BUDGET_VALIDATION_POPUP_TITLE = 'Aviso: Validação de Budget FY27'

export const BUDGET_VALIDATION_POPUP_INTRO =
  'Prezado(a), estamos em período de validação do Budget de FY27 e aguardando a versão final aprovada.'

export const BUDGET_VALIDATION_POPUP_BODY =
  'Durante esse período, o Budget carregado no SmartOps poderá aparecer zerado ou apresentar valores preliminares, ainda não oficiais. Os números exibidos estão sujeitos a alterações até a conclusão de todas as validações pendentes.'

export const BUDGET_VALIDATION_POPUP_CONFIRM_BUTTON_TEXT = 'Ciente'
